import PushChain from "../../../public/assets/General-Img/Home/Our Projects/PushChain.webp";
import PushChain1 from "../../../public/assets/General-Img/Home/Our Projects/PushChain1.webp";
import PushChain2 from "../../../public/assets/General-Img/Home/Our Projects/PushChain2.webp";
import Swiggy from "../../../public/assets/General-Img/Home/Our Projects/Swiggy.webp";
import Swiggy1 from "../../../public/assets/General-Img/Home/Our Projects/Swiggy1.webp";
import Swiggy2 from "../../../public/assets/General-Img/Home/Our Projects/Swiggy2.webp";
import Haut from "../../../public/assets/General-Img/Home/Our Projects/Haut.webp";
import Haut1 from "../../../public/assets/General-Img/Home/Our Projects/Haut1.webp";
import Haut2 from "../../../public/assets/General-Img/Home/Our Projects/Haut2.webp";
import PixelArcadia from "../../../public/assets/General-Img/Home/Our Projects/PixelArcadia.webp";
import PixelArcadia1 from "../../../public/assets/General-Img/Home/Our Projects/PixelArcadia1.webp";
import PixelArcadia2 from "../../../public/assets/General-Img/Home/Our Projects/PixelArcadia2.webp";

export const content = {
  title: "Our Latest Projects",
  description: "",
  data: [
    {
      id: 1,
      bgColor: "bg-[#EDDAFF]",
      logo: PushChain,
      logoName: "PushChain",
      category: "Blockchain",
      description:
        "We build cutting-edge Web3-based push notification solutions, ensuring secure, decentralized, and real-time communication for dApps, wallets, and blockchain platforms. Our technology enables trustless messaging, smart contract-driven alerts, and multi-chain support, keeping users informed while maintaining full data privacy and decentralization.",
      btnName: "View More",
      btnLink: "https://www.tanthetaa.com/portfolio/Webapp-like-push",
      sideDeskImg: PushChain1,
      sideMobileImg: PushChain2,
    },
    {
      id: 2,
      bgColor: "bg-[#FFECE3]",
      logo: Swiggy,
      logoName: "Swiggy",
      category: "On-Demand Solution",
      description:
        "We craft next-gen food delivery apps like Swiggy, designed for seamless user experiences, advanced logistics, and AI-powered personalization. Our solutions ensure fast, reliable, and scalable platforms for restaurants, delivery partners, and customers.",
      btnName: "View More",
      btnLink: "https://www.tanthetaa.com/portfolio/food-delivery-app",
      sideDeskImg: Swiggy1,
      sideMobileImg: Swiggy2,
    },
    {
      id: 3,
      bgColor: "bg-[#ECEEFF]",
      logo: Haut,
      logoName: "Haut.AI",
      category: "HealthCare & Fitness",
      description:
        "We develop AI-powered beauty and skincare analysis platforms like Haut.AI, leveraging cutting-edge computer vision and deep learning. Our solutions enable personalized skin diagnostics, real-time insights, and data-driven recommendations, empowering brands and users with next-gen beauty tech innovations.",
      btnName: "View More",
      btnLink: "https://www.tanthetaa.com/portfolio/skin-care-app-using-ai",
      sideDeskImg: Haut1,
      sideMobileImg: Haut2,
    },
    {
      id: 4,
      bgColor: "bg-[#E9FFF2]",
      logo: PixelArcadia,
      logoName: "Pixel Arcadia",
      category: "AI",
      description:
        "We build AI-driven customer service and support solutions like Pixel Arcade AI, designed to enhance user engagement, streamline queries, and provide real-time assistance. Our AI-powered chatbots and automation tools ensure seamless support, quick resolutions, and personalized interactions, optimizing customer experiences for businesses.",
      btnName: "View More",
      btnLink: "https://www.tanthetaa.com/portfolio/pixelarcadia-ai-agent-case-study",
      sideDeskImg: PixelArcadia1,
      sideMobileImg: PixelArcadia2,
    },
  ],
};
